export default __webpack_public_path__ + "static/media/Axe of the Archaeologian.bd24bf06.jpg";